import parse from 'html-react-parser';
import styles from './schedule-call.module.scss';
import {wallexState} from '../../wallex.state';
import Link from 'next/link';

const ScheduleCall = () => {
  const { scheduleCall: { title, label, url } } = wallexState;

  return (
    <section className={styles.section}>
      <div className={styles.section__banner}>
        <h2 className={styles.section__title}>{parse(title)}</h2>
        <Link href={url}>
          <a className={styles.section__link}>{label}</a>
        </Link>
      </div>
    </section>
  )
}

export default ScheduleCall;
